<template>
  <div class="formLogin">
    <a-form-model :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
      <a-form-model-item prop="userId">
        <a-input size="large" v-model="ruleForm.userId" placeholder="请输入用户ID" allowClear />
      </a-form-model-item>
      <a-form-model-item prop="phone">
        <a-input size="large" v-model="ruleForm.phone" placeholder="请输入手机号" allowClear
          oninput="value=value.replace(/[^0-9]/g,'');if(value.length > 11)value = value.slice(0, 11)" />
      </a-form-model-item>
      <a-form-model-item prop="bizModule">
        <a-select size="large" v-model="ruleForm.bizModule" placeholder="请选择业务模块">
          <a-select-option v-for="item in bizModuleOptions" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <Environment />
    </a-form-model>
    <a-button class="button" @click="submitForm" :loading="btnLoading">登&nbsp;录</a-button>
  </div>
</template>

<script>
import { message } from 'ant-design-vue';
import { post } from '@/utils/http';
import { pointTools, traceClick } from '@/utils/point';
import { getLogo } from '@/utils/intConfiguration';
import Environment from '../environment.vue';
import api from '../../../../api/index';
import {
  rmToken,
} from '../../login-handler';

// 本地环境跳转域名
const LOCAL_REDIRECT_ORIGIN = 'http://localhost:3070';

export default {
  name: 'ThirdLogin',
  components: {
    Environment,
  },
  props: ['agree'],
  data() {
    return {
      btnLoading: false,
      ruleForm: {
        userId: '',
        phone: '',
        bizModule: undefined,
      },
      bizModuleOptions: [
        { label: '智慧大屏', value: 'screen' },
        { label: '项目列表', value: 'project' },
      ],
      rules: {
        userId: [
          { required: true, message: '请输入用户ID', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[0-9]{10}$/, message: '手机号码格式不正确', trigger: 'change' },
        ],
        bizModule: [
          { required: true, message: '请选择业务模块', trigger: 'change' },
        ],
      },
      logoUi: getLogo(),
    };
  },
  computed: {
    // 是否本地开发环境
    env() {
      let env = false;
      try {
        env = process.env.NODE_ENV === 'development';
      } catch (e) {
        env = false;
      }
      return env;
    },
  },
  methods: {
    /// 登录操作
    submitForm() {
      pointTools.traceClick({
        event_type: 'web_click',
        content: {
          event_id: 'page_login_clk',
          event_name: '登录页登录按钮',
        },
      });
      traceClick(
        {
          event_type: 'web_click',
          content: {
            event_id: 'auth_login_third_click',
            event_name: '登录 - 三方登录',
          },
        },
        true,
      );
      if (this.agree != true) {
        message.error('请勾选确认已经阅读并同意以下协议!');
        return;
      }
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          rmToken(); // 清除 token
          this.btnLoading = true;
          const params = {
            userId: this.ruleForm.userId,
            phone: this.ruleForm.phone,
            bizModule: this.ruleForm.bizModule,
          };
          const loginRes = await post(api.thirdLogin, params).catch(() => {
            // message.error('登录失败');
          });
          this.btnLoading = false;
          if (loginRes && loginRes.success && loginRes.redirectUrl) {
            message.success('登录成功');
            let { redirectUrl } = loginRes;
            // 本地环境：把 redirectUrl 的域名替换成本地地址
            if (this.env) {
              redirectUrl = redirectUrl.replace(/^https?:\/\/[^/]+/, LOCAL_REDIRECT_ORIGIN);
            }
            // 在当前窗口打开
            window.open(redirectUrl, '_self');
          }
        }
      });
    },
  },
};
</script>
<style lang="less">
.ant-btn:focus {
  box-shadow: none;
  border: 0 none;
  outline: none;
}
</style>
